export const Field = ({ label, hint, children }) => (
  <div className="lg-field">
    <label>{label}</label>
    {children}
    {hint && <small>{hint}</small>}
  </div>
);

export const NumInput = ({ value, onChange, testid, placeholder }) => (
  <input className="lg-input" inputMode="numeric" value={value} placeholder={placeholder}
    onChange={(e) => onChange(e.target.value.replace(/[^\d.,]/g, ""))} data-testid={testid} />
);
